import { createSessionCookie, createRefCookie } from '@ltvco/refresh-lib/utils';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

import LocationChangeListener from 'components/locationChangeListener/LocationChangeListener';

import App from './App';
import './index.css';

import '@ltvco/refresh-lib/dist/lib/style.css';

const prefix = import.meta.env.VITE_PATH_PREFIX;

// Third-party scripts injected via GTM (e.g. AccessiBe/acsb.js) scroll the
// page ~500ms after load. Lock scroll to the top for 1s from initial JS
// execution. This runs as plain module code — unaffected by React StrictMode's
// double-invoke of effects.
if (window.location.pathname.includes('/dashboard/home')) {
  const handleInitialScrollLock = () => {
    if (window.scrollY !== 0) {
      window.scrollTo(0, 0);
    }
  };

  window.addEventListener('scroll', handleInitialScrollLock);
  window.setTimeout(() => {
    window.removeEventListener('scroll', handleInitialScrollLock);
  }, 1000);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <BrowserRouter basename={prefix}>
      <QueryParamProvider adapter={ReactRouter6Adapter}>
        <LocationChangeListener />
        <App />
      </QueryParamProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

createSessionCookie();
createRefCookie();
